import {call, put} from 'redux-saga/effects';
import {receiveSitemapData} from "../actions/sitemapActions";
import {fetchSitemapData} from "../api/fetchSitemapData";

export default function* getSitemapData(action) {
    try {
        const sitemapData = yield call(fetchSitemapData);
        yield put(receiveSitemapData(sitemapData));
    } catch (e) {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/sitemapSaga.js